import { ReactNode } from "react";
import { Color, Style } from "../alerts/alert-variants";
import { cn } from "../../utils/cn";

interface CalloutBoxProps {
  children: ReactNode;
  color: Color;
  style: Style;
  className?: string;
}

const baseStyle = "rounded-md flex gap-x-3.5";
const solidStyles = "p-4";

const solidColorVariants: Record<Color, string> = {
  green: "text-neutral-white bg-glen",
  blue: "text-neutral-white bg-loch",
  white: "text-north-sea bg-neutral-white",
  amber: "text-neutral-white bg-autumn",
  red: "text-neutral-white bg-brick",
  gray: "text-neutral-white bg-light-slate",
  dark: "text-neutral-white bg-slate",
};

const outlineStyles = "border p-4";
const outlineColorVariants: Record<Color, string> = {
  green: "text-glen bg-glen-50 border-glen",
  blue: "text-loch bg-loch-50 border-loch",
  white: "text-north-sea bg-neutral-white border-north-sea",
  amber: "text-autumn bg-autumn-50 border-autumn",
  red: "text-brick bg-brick-50 border-brick",
  gray: "text-light-slate bg-light-cloud border-light-slate",
  dark: "text-slate bg-light-cloud border-slate",
};

export const CalloutBox = ({ children, color, style, className }: CalloutBoxProps) => {
  const styleVariant = style === "solid" ? solidColorVariants[color] : outlineColorVariants[color];
  const padding = style === "solid" ? solidStyles : outlineStyles;

  return <div className={cn(baseStyle, styleVariant, padding, className)}>{children}</div>;
};
